/*
  LZ Prestige lender: izbor boje (hero, sticky, set, mreža), veličine iz varijanti, dodavanje u korpu kroz
  cart drawer teme, "Složi set" sa pragom besplatne dostave, story kartice, tabovi, audio kartice.
  Podaci dolaze iz <script type="application/json" data-colors|data-partners> koje renderuje sections/lz-prestige.liquid.
*/
(function () {
  'use strict';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function parseJSON(el) { try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } }

  function init(root) {
    if (root.__lzPrst) return;
    root.__lzPrst = true;

    var colors = parseJSON(qs(root, '[data-colors]'));
    var partners = parseJSON(qs(root, '[data-partners]'));
    if (!colors.length) return;

    var d = root.dataset;
    var THRESHOLD = parseInt(d.freeThreshold, 10) || 800000;
    var SHIP = parseInt(d.shippingCost, 10) || 0;
    var STORY_MS = parseInt(d.storyMs, 10) || 5000;
    var CUR = d.currency || 'RSD';
    var CUR_LABEL = CUR === 'BAM' ? 'KM' : CUR;
    var L = {
      avail: d.labelAvailable || 'Dostupno:',
      soldout: d.labelSoldout || 'rasprodato',
      size: d.labelSize || 'Izaberi veličinu',
      add: d.labelAdd || 'Dodaj u korpu',
      shipFree: d.labelShipFree || 'Dostava besplatna',
      shipMissing: d.labelShipMissing || 'Do besplatne dostave fali {amount}',
      pickBoth: d.labelPickBoth || 'Izaberi veličine za oba komada.',
      error: d.labelError || 'Nije uspelo dodavanje u korpu.',
      saving: d.labelSaving || ''
    };
    var brand = d.brand || 'Prestige';

    function money(cents) {
      var v = cents / 100;
      var whole = Math.floor(v);
      var frac = Math.round((v - whole) * 100);
      var str = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (frac) str += ',' + (frac < 10 ? '0' : '') + frac;
      return str + ' ' + CUR_LABEL;
    }

    var state = { color: 0, sizeId: null, partner: 0, partnerSizeId: null, setSizesOpen: false };

    /* ---------- elementi ---------- */
    var heroImg = qs(root, '[data-hero-img]');
    var heroPrice = qs(root, '[data-hero-price]');
    var heroColor = qs(root, '[data-hero-color]');
    var stockLine = qs(root, '[data-stock-line]');
    var swatches = qsa(root, '[data-swatches] [data-color-index]');
    var gridItems = [];
    (function buildGrid() {
      var grid = document.querySelector('[data-color-grid]');
      if (!grid) return;
      grid.innerHTML = '';
      colors.forEach(function (c, i) {
        var li = document.createElement('li');
        li.className = 'lz-prst__color' + (i === 0 ? ' lz-prst__color--active' : '');
        li.setAttribute('data-color-index', String(i));
        li.innerHTML = '<a class="lz-prst__color-link" href="' + c.url + '"><div class="lz-prst__photo lz-prst__color-photo"><img src="' + c.pack + '" width="200" height="267" alt="" loading="lazy"></div><div class="lz-prst__color-name"></div></a>';
        li.querySelector('.lz-prst__color-name').textContent = c.name;
        li.querySelector('a').setAttribute('aria-label', brand + ' ' + c.name);
        grid.appendChild(li);
        gridItems.push(li);
      });
    })();
    var sticky = qs(root, '[data-sticky]');
    var stickyImg = qs(root, '[data-sticky-img]');
    var stickyName = qs(root, '[data-sticky-name]');
    var stickyPrice = qs(root, '[data-sticky-price]');
    var stickyCta = qs(root, '[data-sticky-cta]');
    var stickySizes = qs(root, '[data-sticky-sizes]');
    var stickyMsg = qs(root, '[data-sticky-msg]');

    /* ---------- pomoćne ---------- */
    function variantById(list, id) {
      for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
      return null;
    }
    function buildChips(container, variants, selectedId, onPick) {
      if (!container) return;
      container.innerHTML = '';
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lz-prst__size' + (v.a ? '' : ' lz-prst__size--soldout') + (String(v.id) === String(selectedId) ? ' lz-prst__size--active' : '');
        b.textContent = v.size;
        if (!v.a) b.disabled = true;
        b.setAttribute('aria-pressed', String(v.id) === String(selectedId) ? 'true' : 'false');
        b.addEventListener('click', function () {
          qsa(container, '.lz-prst__size').forEach(function (x) { x.classList.remove('lz-prst__size--active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('lz-prst__size--active');
          b.setAttribute('aria-pressed', 'true');
          onPick(v);
        });
        container.appendChild(b);
      });
    }
    function setImg(img, src, src2x) {
      if (!img || !src) return;
      img.src = src;
      if (src2x) img.srcset = src + ' 1x, ' + src2x + ' 2x'; else img.removeAttribute('srcset');
    }
    function stockText(c) {
      var avail = [], out = [];
      c.variants.forEach(function (v) { (v.a ? avail : out).push(v.size); });
      var html = '';
      if (avail.length) html += L.avail + ' ' + avail.join(', ');
      if (out.length) html += (avail.length ? ' · ' : '') + '<span class="lz-prst__stock-out">' + out.join(', ') + ' ' + L.soldout + '</span>';
      return html;
    }

    /* ---------- boja ---------- */
    function selectColor(idx, opts) {
      opts = opts || {};
      if (!colors[idx]) return;
      state.color = idx;
      state.sizeId = null;
      var c = colors[idx];
      setImg(heroImg, c.hero, c.hero2x);
      if (heroImg) heroImg.alt = brand + ' ' + c.name;
      if (heroPrice) heroPrice.textContent = money(c.price);
      if (heroColor) heroColor.textContent = c.name;
      if (stockLine) stockLine.innerHTML = stockText(c);
      swatches.forEach(function (b) {
        var on = parseInt(b.getAttribute('data-color-index'), 10) === idx;
        b.classList.toggle('lz-prst__swatch--active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      gridItems.forEach(function (li) {
        li.classList.toggle('lz-prst__color--active', parseInt(li.getAttribute('data-color-index'), 10) === idx);
      });
      setImg(stickyImg, c.thumb);
      if (stickyName) stickyName.textContent = brand + ' · ' + c.name;
      syncBuy();
      if (opts.openSizes) stickyBuy.open();
      renderSet();
    }
    swatches.forEach(function (b) {
      b.addEventListener('click', function () { selectColor(parseInt(b.getAttribute('data-color-index'), 10)); });
    });
    /* mreža boja na dnu su linkovi na PDP svake boje (Markov zahtev 01.10.2026) */

    /* ---------- kupovina: hero blok + sticky traka dele isti izbor veličine ---------- */
    function buyBlock(o) {
      var open = false;
      function render() {
        var c = colors[state.color];
        if (o.sizes) {
          buildChips(o.sizes, c.variants, state.sizeId, function (v) {
            state.sizeId = v.id;
            if (o.msg) o.msg.textContent = '';
            syncBuy();
            renderSetSizes();
          });
          o.sizes.hidden = !open;
        }
        if (o.cta) o.cta.textContent = state.sizeId ? L.add : L.size;
        if (o.price) {
          var v = variantById(c.variants, state.sizeId);
          o.price.textContent = money(c.price) + (v ? ' · ' + v.size : '');
        }
      }
      if (o.cta) {
        o.cta.addEventListener('click', function () {
          if (!open) { open = true; render(); return; }
          if (!state.sizeId) { if (o.msg) o.msg.textContent = L.size; return; }
          addToCart([{ id: state.sizeId, quantity: 1 }], o.cta, o.msg);
        });
      }
      return { render: render, open: function () { open = true; render(); } };
    }
    var heroBuy = buyBlock({ cta: qs(root, '[data-hero-cta]'), sizes: qs(root, '[data-hero-sizes]'), msg: qs(root, '[data-hero-msg]') });
    var stickyBuy = buyBlock({ cta: stickyCta, sizes: stickySizes, msg: stickyMsg, price: stickyPrice });
    function syncBuy() { heroBuy.render(); stickyBuy.render(); }

    /* sticky traka se pojavljuje tek kad hero dugme izađe iz vidokruga (skrol naniže) */
    var heroBuyEl = qs(root, '[data-hero-buy]');
    function updateSticky() {
      if (!sticky) return;
      var show = true;
      if (heroBuyEl) {
        var r = heroBuyEl.getBoundingClientRect();
        show = r.bottom < 0;
      }
      sticky.classList.toggle('lz-prst__sticky-wrap--visible', show);
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);

    var finalCta = document.querySelector('[data-final-cta]');
    if (finalCta) finalCta.addEventListener('click', function () { stickyBuy.open(); updateSticky(); if (stickySizes) stickySizes.scrollIntoView({ block: 'end', behavior: 'smooth' }); });

    /* ---------- korpa ---------- */
    function addToCart(items, btn, msgEl) {
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',') : '';
      var body = { items: items };
      if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
      if (btn) { btn.classList.add('lz-prst__btn--loading'); btn.setAttribute('aria-disabled', 'true'); }
      if (msgEl) msgEl.textContent = '';
      var url = (d.cartAddUrl || '/cart/add');
      if (!/\.js$/.test(url)) url += '.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (btn) { btn.classList.remove('lz-prst__btn--loading'); btn.removeAttribute('aria-disabled'); }
        if (res.status) {
          if (msgEl) msgEl.textContent = res.description || res.message || L.error;
          return;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lz-prestige', cartData: res }); } catch (e) {}
        }
        if (drawer && drawer.renderContents && res.sections) {
          drawer.renderContents(res);
        } else {
          window.location.href = d.cartUrl || '/cart';
        }
      }).catch(function () {
        if (btn) { btn.classList.remove('lz-prst__btn--loading'); btn.removeAttribute('aria-disabled'); }
        if (msgEl) msgEl.textContent = L.error;
      });
    }

    /* ---------- set ---------- */
    var setRoot = qs(root, '[data-set]');
    var setMainImg = qs(root, '[data-set-main-img]');
    var setMainName = qs(root, '[data-set-main-name]');
    var setMainPrice = qs(root, '[data-set-main-price]');
    var setPartnerImg = qs(root, '[data-set-partner-img]');
    var setPartnerName = qs(root, '[data-set-partner-name]');
    var setPartnerPrice = qs(root, '[data-set-partner-price]');
    var setTotal = qs(root, '[data-set-total]');
    var shipTag = qs(root, '[data-ship-tag]');
    var shipTagText = qs(root, '[data-ship-tag-text]');
    var shipProgress = qs(root, '[data-ship-progress]');
    var shipMissingText = qs(root, '[data-ship-missing-text]');
    var shipFill = qs(root, '[data-ship-fill]');
    var setSizes = qs(root, '[data-set-sizes]');
    var setSizesMain = qs(root, '[data-set-sizes-main]');
    var setSizesPartner = qs(root, '[data-set-sizes-partner]');
    var setSizesMainLabel = qs(root, '[data-set-sizes-main-label]');
    var setSizesPartnerLabel = qs(root, '[data-set-sizes-partner-label]');
    var setAdd = qs(root, '[data-set-add]');
    var setMsg = qs(root, '[data-set-msg]');
    var partnerTabs = qsa(root, '[data-partner-tab]');

    function renderSet() {
      if (!setRoot || !partners.length) return;
      var c = colors[state.color];
      var p = partners[state.partner] || partners[0];
      setImg(setMainImg, c.pack);
      if (setMainName) setMainName.textContent = brand + ' · ' + c.name;
      if (setMainPrice) setMainPrice.textContent = money(c.price);
      setImg(setPartnerImg, p.pack);
      if (setPartnerName) setPartnerName.textContent = p.title;
      if (setPartnerPrice) setPartnerPrice.textContent = money(p.price);
      var total = c.price + p.price;
      if (setTotal) setTotal.textContent = money(total);
      var free = total >= THRESHOLD;
      if (shipTag) shipTag.classList.toggle('lz-prst__ship-tag--hidden', !free);
      if (shipTagText) shipTagText.textContent = L.shipFree;
      if (shipProgress) shipProgress.classList.toggle('lz-prst__ship-progress--hidden', free);
      if (shipMissingText) shipMissingText.textContent = L.shipMissing.replace('{amount}', money(THRESHOLD - total));
      if (shipFill) shipFill.style.width = Math.min(100, Math.round(total / THRESHOLD * 100)) + '%';
      var note = qs(root, '[data-set-note]');
      if (note) note.textContent = (free && SHIP > 0 && L.saving) ? L.saving.replace('{amount}', money(SHIP)) : '';
      partnerTabs.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-partner-tab'), 10) === state.partner;
        t.classList.toggle('lz-prst__tab--active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (setMsg) setMsg.textContent = '';
      renderSetSizes();
    }
    function renderSetSizes() {
      if (!setSizes || setSizes.hidden) return;
      var c = colors[state.color];
      var p = partners[state.partner] || partners[0];
      if (setSizesMainLabel) setSizesMainLabel.textContent = brand + ' · ' + c.name;
      if (setSizesPartnerLabel) setSizesPartnerLabel.textContent = p.title;
      buildChips(setSizesMain, c.variants, state.sizeId, function (v) { state.sizeId = v.id; if (setMsg) setMsg.textContent = ''; syncBuy(); });
      if (state.partnerSizeId && !variantById(p.variants, state.partnerSizeId)) state.partnerSizeId = null;
      buildChips(setSizesPartner, p.variants, state.partnerSizeId, function (v) { state.partnerSizeId = v.id; if (setMsg) setMsg.textContent = ''; });
    }
    partnerTabs.forEach(function (t) {
      t.addEventListener('click', function () { state.partner = parseInt(t.getAttribute('data-partner-tab'), 10); state.partnerSizeId = null; renderSet(); });
    });
    if (setAdd) {
      setAdd.addEventListener('click', function () {
        if (setSizes && setSizes.hidden) { setSizes.hidden = false; renderSetSizes(); return; }
        if (!state.sizeId || !state.partnerSizeId) { if (setMsg) setMsg.textContent = L.pickBoth; return; }
        addToCart([{ id: state.sizeId, quantity: 1 }, { id: state.partnerSizeId, quantity: 1 }], setAdd, setMsg);
      });
    }

    /* ---------- osnivač ---------- */
    var founder = qs(root, '[data-founder]');
    var founderToggle = qs(root, '[data-founder-toggle]');
    if (founder && founderToggle) {
      founderToggle.addEventListener('click', function () {
        var open = founder.classList.toggle('lz-prst__founder--open');
        founderToggle.textContent = open ? founderToggle.getAttribute('data-less') : founderToggle.getAttribute('data-more');
        founderToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* ---------- story ---------- */
    var storiesRoot = qs(root, '[data-stories]');
    if (storiesRoot) {
      var stories = qsa(storiesRoot, '[data-story]');
      var sIdx = 0, timer = null, startedAt = 0, remaining = STORY_MS, paused = false, visible = false;
      storiesRoot.style.setProperty('--lz-story-ms', STORY_MS + 'ms');

      function paintBars() {
        stories.forEach(function (st, i) {
          st.classList.toggle('lz-prst__story--active', i === sIdx);
          qsa(st, '[data-story-bar]').forEach(function (bar) {
            var bi = parseInt(bar.getAttribute('data-story-bar'), 10);
            bar.classList.remove('lz-prst__story-bar--active', 'lz-prst__story-bar--done');
            if (bi < sIdx) bar.classList.add('lz-prst__story-bar--done');
            if (bi === sIdx && i === sIdx) { void bar.offsetWidth; bar.classList.add('lz-prst__story-bar--active'); }
          });
        });
      }
      function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }
      function schedule(ms) {
        clearTimer();
        startedAt = Date.now();
        remaining = ms;
        timer = setTimeout(function () { go(sIdx + 1); }, ms);
      }
      function go(n) {
        sIdx = (n + stories.length) % stories.length;
        paintBars();
        storiesRoot.classList.remove('lz-prst__stories--paused');
        paused = false;
        if (visible) schedule(STORY_MS);
      }
      function pause() {
        if (paused) return;
        paused = true;
        remaining = Math.max(300, remaining - (Date.now() - startedAt));
        clearTimer();
        storiesRoot.classList.add('lz-prst__stories--paused');
      }
      function resume() {
        if (!paused) return;
        paused = false;
        storiesRoot.classList.remove('lz-prst__stories--paused');
        if (visible) schedule(remaining);
      }
      var holdTimer = null, held = false;
      stories.forEach(function (st) {
        var prev = qs(st, '[data-story-prev]'), next = qs(st, '[data-story-next]');
        [prev, next].forEach(function (btn) {
          if (!btn) return;
          btn.addEventListener('pointerdown', function () { held = false; holdTimer = setTimeout(function () { held = true; pause(); }, 220); });
          btn.addEventListener('pointerup', function () { clearTimeout(holdTimer); if (held) { resume(); held = false; } });
          btn.addEventListener('pointerleave', function () { clearTimeout(holdTimer); if (held) { resume(); held = false; } });
          btn.addEventListener('click', function () { if (held) return; go(sIdx + (btn === next ? 1 : -1)); });
        });
      });
      paintBars();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            visible = en.isIntersecting;
            if (visible) { paintBars(); schedule(STORY_MS); } else { clearTimer(); }
          });
        }, { threshold: 0.35 }).observe(storiesRoot);
      } else { visible = true; schedule(STORY_MS); }
    }

    /* ---------- kako ga nosiš ---------- */
    var wearTabs = qsa(root, '[data-wear-tab]');
    var wearPanels = qsa(root, '[data-wear-panel]');
    wearTabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-wear-tab');
        wearTabs.forEach(function (x) { var on = x === t; x.classList.toggle('lz-prst__tab--active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        wearPanels.forEach(function (p) { p.classList.toggle('lz-prst__wear-panel--active', p.getAttribute('data-wear-panel') === i); });
      });
    });

    /* ---------- ljudi (audio) ---------- */
    var voices = qsa(root, '[data-voice]');
    var current = null;
    voices.forEach(function (card) {
      var media = qs(card, '[data-voice-media]');
      var play = qs(card, '[data-voice-play]');
      if (!media || !play) return;
      function stop() {
        media.pause();
        card.classList.remove('lz-prst__voice--playing');
        play.setAttribute('aria-label', 'Pusti');
      }
      play.addEventListener('click', function () {
        if (!media.paused) { stop(); return; }
        if (current && current !== media) { current.pause(); var oc = current.closest('[data-voice]'); if (oc) oc.classList.remove('lz-prst__voice--playing'); }
        current = media;
        media.muted = false;
        var p = media.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add('lz-prst__voice--playing');
        play.setAttribute('aria-label', 'Pauziraj');
      });
      media.addEventListener('timeupdate', function () {
        if (media.duration) card.style.setProperty('--progress', Math.round(media.currentTime / media.duration * 100) + '%');
      });
      media.addEventListener('ended', function () { stop(); card.style.setProperty('--progress', '0%'); media.currentTime = 0; });
    });

    /* ---------- start ---------- */
    selectColor(0);
    updateSticky();
  }

  function boot() { qsa(document, '[data-lz-prst]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { qsa(e.target, '[data-lz-prst]').forEach(init); });
})();
